// permissions that cannot be passed on to the customer at business
export const permissionsThatBusinessCannotPassOn = [
  'view-grafana-especialist',
  'view-grafana-monitor',
  'view-contracts',
  'view-invoices',
  'transfer',
  'batch-transfer',
  'download-invoices',
  'view-transfers',
  'view-autoservices',
  'contract-suspend',
  'roaming',
  'view-requests',
  'simcard-import',
  'contract-suspend',
  'batch-contract-suspend',
];
